import { useInstance } from '../support/ioc/useInstance';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';
import { Page } from '../components/page/Page.tsx';
import { useEditableMissionState } from '../missions/model/useEditableMissionState.tsx';
import { usePageView } from '../support/tracking/usePageView.tsx';
import { WindyMissionMap } from './windy/WindyMissionMap.tsx';
import { MissionColorProvider } from '../flight-checklist/MissionColorProvider.ts';
import { Theme } from '../app/ThemeVariables.ts';

export const WeatherMapPage: React.FC<{ missionId: string }> = ({ missionId }) => {
    usePageView('Weather Map');

    const history = useInstance(HistoryViewModel);

    const colorProvider = useInstance(MissionColorProvider);
    const theme = useInstance(Theme);
    const mission = useEditableMissionState(missionId);

    if (!mission) {
        return null;
    }

    const center = mission.getLocation();
    const radiusMeters = mission.getMissionRadius().getMissionRadius().properties.radiusMeters;
    const startTime = mission.getStartTime();
    const radiusColor = theme.getColor(colorProvider.getColor(mission.getMissionRadius()));
    const radiusShape = mission.getMissionRadius().getMissionRadius().properties.isSquare ? 'square' : 'circle';

    return (
        <Page onBack={() => history.back(mission.pages.weather.path())} fullWidth>
            <WindyMissionMap
                center={center}
                radiusMeters={radiusMeters}
                radiusColor={radiusColor}
                radiusShape={radiusShape}
                startTime={startTime}
            />
        </Page>
    );
};
